import FilterTemplate from "src/components/Layouts/FilterTemplate";
import useRenderFilterFields from "./hooks/useRenderFilterFields";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { FilterFields } from "../../types/FilterFields";
import { GetListRes } from "../../types/GetListRes";
import AddWallletBalanceMonitorButton from "./components/AddWallletBalanceMonitorButton";
import AddWalletBalanceMonitorDialog from "./components/AddWalletBalanceMonitorDialog";
import AddWalletBalanceMonitorDialogProvider from "src/features/DialogProvider";
import { FeatureCode } from "@wallet-manager/node-types";

function Filter() {
  const { translatePrefix, fields, setFields, list } =
    usePageConfigProviderContext<FilterFields, GetListRes>();

  const { renderFields } = useRenderFilterFields({
    translatePrefix,
    fields,
    setFields,
  });

  return (
    <FilterTemplate
      extraButtons={
        <AddWalletBalanceMonitorDialogProvider
          permissionKey={
            FeatureCode.FeaturesWalletManagement.WalletBalanceMonitor.Add
          }
        >
          <AddWallletBalanceMonitorButton />
          <AddWalletBalanceMonitorDialog />
        </AddWalletBalanceMonitorDialogProvider>
      }
      renderFields={renderFields}
    />
  );
}

export default Filter;
